import api from '@/core/api';
import HttpStatusError from '@/core/http-module/error/http-status-error';
import HttpResponse from '@/core/http-module/http-response';
import useCountry from '@/composables/countryDependable';
import {useApplicationData} from '@/composables/applicationCart/applicationData';
import {ref} from 'vue';
import {useI18n} from 'vue-i18n';

const useApplicationCart = () => {
    const { t } = useI18n()
    const {displayCode} = useCountry();
    const {applicationData} = useApplicationData();
    const paymentRef = ref('');

    const submitApplication = async () => {
        const response = await api.application.sync(applicationData.value, displayCode.toLowerCase());

        //application already paid
        if (response instanceof HttpStatusError && response.status === 555) {
            return {
                success: false,
                data: []
            };
        }

        //validation data issue
        if (response instanceof HttpStatusError && response.status === 400) {
            const error: string[] = [t('message.error.short')];
            response.content.errors?.forEach((errorItem: any) => {
                if ((errorItem as { detail: string; source: string }).detail) {
                    error.push((errorItem as { detail: string; source: string }).detail);
                }
            })

            return {
                success: false,
                data: error
            };
        }

        if(!(response instanceof HttpResponse)) {
            return {
                success: false,
                data: [
                    t('message.error.default')
                ]
            };
        }

        paymentRef.value = response.content.data.paymentRef;

        return {
            success: true,
            data: response.content.data,
        };
    }

    return {
        submitApplication,
        paymentRef,
    }
}

export default useApplicationCart;